module.exports = __webpack_public_path__ + "media/components/video_discovery/assets/Complete_Video_Header_Buttons-948b8a963e911afc061f55368098ec38.svg";